import React from 'react'
import styled from 'styled-components'
import { Segment as UnstyledSegment, Button } from 'semantic-ui-react'
import DeleteConfirmationButton from 'organisms/DeleteConfirmationButton'

const Segment = styled(UnstyledSegment)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.ui.segment {
    border: 1px solid rgba(34, 36, 38, 0.15);
  }
`
const ChannelName = styled.h4`
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ButtonGroup = styled.div`
  min-width: 90px;
  margin-left: 10px;
`

/**
 * @param {object} props
 * @param {import('components/IntegrationWebhookModal').WebhookSetting} props.webhookSetting
 * @param {function} props.onDelete
 * @param {function} props.onSelect
 */
export default function IntegrationWebhookSegment({ webhookSetting, onDelete, onSelect }) {
  return (
    <Segment>
      <ChannelName>{webhookSetting.name || webhookSetting.url}</ChannelName>
      <ButtonGroup>
        <Button basic icon onClick={onSelect}>
          <i className="far fa-edit icon" />
        </Button>
        <DeleteConfirmationButton
          actionButtonLabel="Yes, do it."
          title="Are you sure?"
          onDelete={onDelete}
          loading={false}
        >
          <Button basic icon>
            <i className="far fa-trash-can icon" />
          </Button>
        </DeleteConfirmationButton>
      </ButtonGroup>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/IntegrationWebhookSegment/index.js